export class EventSubprocessor {
    static removeProcessorPrefix(path, prefix) {
        return path.replace(`${prefix}:`, '');
    }
}
